require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconCircleCheckBig.tsx
var IconCircleCheckBig_exports = {};
__export(IconCircleCheckBig_exports, {
  default: () => IconCircleCheckBig_default
});
module.exports = __toCommonJS(IconCircleCheckBig_exports);

// src/assets/monochrome/circleCheckBig.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgCircleCheckBig = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.7168 3.55871C12.2441 2.70898 10.5246 2.3898 8.84506 2.65441C7.16551 2.91902 5.62743 3.75142 4.48733 5.0128C3.34723 6.27417 2.67401 7.88828 2.57995 9.58594C2.48588 11.2836 2.97666 12.9622 3.97043 14.3418C4.96421 15.7214 6.40091 16.7186 8.04094 17.1672C9.68098 17.6157 11.4252 17.4885 12.9828 16.8066C14.5403 16.1248 15.8171 14.9296 16.6001 13.4204C17.3831 11.9111 17.625 10.1791 17.2856 8.51303C17.1863 8.02598 17.5007 7.5507 17.9877 7.45145C18.4748 7.35221 18.9501 7.66659 19.0493 8.15364C19.471 10.2231 19.1705 12.3746 18.1979 14.2493C17.2253 16.124 15.6393 17.6086 13.7046 18.4556C11.7699 19.3025 9.60327 19.4606 7.5661 18.9034C5.52892 18.3463 3.74432 17.1076 2.5099 15.3939C1.27548 13.6802 0.665862 11.5951 0.782702 9.48636C0.899542 7.37761 1.73578 5.37264 3.15196 3.80582C4.56815 2.239 6.47867 1.20503 8.56493 0.876343C10.6512 0.547657 12.7871 0.944122 14.6164 1.99962C15.0469 2.24803 15.1946 2.79842 14.9461 3.22895C14.6977 3.65948 14.1473 3.80712 13.7168 3.55871ZM18.9697 2.69694C19.3211 3.04841 19.3211 3.61826 18.9697 3.96973L10.6363 12.3031C10.4675 12.4718 10.2386 12.5667 9.99994 12.5667C9.76124 12.5667 9.53232 12.4718 9.36354 12.3031L6.86354 9.80306C6.51207 9.45159 6.51207 8.88174 6.86354 8.53027C7.21501 8.1788 7.78486 8.1788 8.13633 8.53027L9.99994 10.3939L17.6969 2.69694C18.0483 2.34546 18.6182 2.34546 18.9697 2.69694Z", fill: "#676F7E" }) });
var circleCheckBig_default = SvgCircleCheckBig;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconCircleCheckBig.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconCircleCheckBig = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(circleCheckBig_default, {}) });
};
IconCircleCheckBig.displayName = "IconCircleCheckBig";
var IconCircleCheckBig_default = IconCircleCheckBig;
